module.exports = __webpack_public_path__ + "img/mpWeixin.aad0520b.jpg";